import CrimeVictimTab from "../../../../patient/details/crimevictim/CrimeVictimTab";

export default function CrimeVictimDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <CrimeVictimTab inWorkQ={inWorkQ} />
    </div>
}
